import { Directive, ElementRef, Input, Renderer2, OnChanges } from '@angular/core';

@Directive({
  selector: '[appButtonColor]'
})
export class ButtonColorDirective implements OnChanges {
  @Input() appButtonColor: string | undefined;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges() {
    this.updateButtonColor();
  }

  private updateButtonColor() {
    const element = this.el.nativeElement;
    this.renderer.removeClass(element, 'button-enCurso');
    this.renderer.removeClass(element, 'button-finalizado');
    this.renderer.removeClass(element, 'button-pendiente');

    switch (this.appButtonColor) {
      case 'EnCurso':
        this.renderer.addClass(element, 'button-enCurso');
        break;
      case 'Cancelada':
        this.renderer.addClass(element, 'button-cancelada');
        break;
      case 'Finalizada':
        this.renderer.addClass(element, 'button-finalizada');
        break;
      default:
        break;
    }
  }
}
